<mat-dialog-content class="edit-dialog__content">
    <div class="edit-dialog__header-wrapper">
        <div class="edit-dialog__header">
            <div class="edit-dialog__title">
                {{ data.row?.name }}
            </div>
            <div class="edit-dialog__subtitle" *ngIf="subtitleText">({{ subtitleText }})</div>
        </div>
        <button class="edit-dialog__close" mat-dialog-close mat-icon-button type="button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="edit-dialog__form" [formGroup]="valueForm">
        <ng-container *ngFor="let field of fields">
            <mat-checkbox
                *ngIf="field.isBoolean"
                [formControl]="field.control"
                class="edit-dialog__checkbox-field"
                color="primary"
            >
                {{ field.label }}
            </mat-checkbox>

            <mat-form-field
                *ngIf="!field.isBoolean"
                class="edit-dialog__value-field"
                [id]="'value-' + field.index"
                appearance="fill"
            >
                <mat-label>
                    {{ field.label }}
                </mat-label>
                <input
                    [formControl]="field.control"
                    matInputCommaDot
                    [attr.data-type]="field.inputDataType"
                    matInput
                    type="text"
                    [errorStateMatcher]="errorMatcher"
                    (keydown.enter)="onFormSubmit()"
                />
                <mat-error>
                    <ui-validation-message [control]="field.control"></ui-validation-message>
                </mat-error>
            </mat-form-field>
        </ng-container>
    </div>

    <mat-form-field class="edit-dialog__date-field" appearance="fill">
        <mat-label>{{ 'editCellValueDialog.date' | translate }}</mat-label>
        <ui-date-time-picker
            [formControl]="dateControl"
            [timelabel]="'editCellValueDialog.time' | translate"
            [hideDateIcon]="true"
            [hideTimeIcon]="true"
        ></ui-date-time-picker>
    </mat-form-field>

    <div class="edit-dialog__actions">
        <button mat-button class="edit-dialog__cancel" color="primary" (click)="onCancel()">
            {{ (viewOnly ? 'editCellValueDialog.close' : 'editCellValueDialog.cancel') | translate }}
        </button>
        <button
            *ngIf="!viewOnly"
            mat-raised-button
            color="primary"
            cdkFocusInitial
            [disabled]="isSaveDisabled"
            (click)="onFormSubmit()"
        >
            {{ 'editCellValueDialog.save' | translate }}
        </button>
    </div>
</mat-dialog-content>
